<template>
  <div style="background: #ffffff">
    <div class="OrderDetails">
      <div class="trajectory">
        <el-input
          placeholder="请输入单号查询"
          v-model.trim="inos"
          clearable
          @clear="handleClear"
          style="width: 1200px;"
        >
          <template slot="append"
            ><el-button
              style="width: 202px; height: 50px"
              @click="Searchgj"
              type="primary"
              >轨迹查询</el-button
            ></template
          >
        </el-input>
      </div>

      <div class="eg-init-wrap" v-if=" !queryIng || (activities.length == 0 && isNoTrack == false)">
          <!-- 标题 -->
          <el-alert  title="订单轨迹示例：" type="warning"  class="text"  :closable="false"></el-alert>
      <div class="eg-init-wrap" v-if="  !queryIng || (activities.length == 0 && isNoTrack == false)">
        <div class="trajectory-info">
          <div class="trajectory-all">
            <div class="trajectory-top">
              <div class="trajectory-left">
                <div class="trajectory-imgs">
                  <img :src="ossPath + '/pages/home/icon-order-track.png'" alt="" />
                </div>
                <div class="trajectory-order">
                  <p>订单号：CNUS01HY2203280164</p>
                  <p>客户单号：MRSE2223423</p>
                  <!-- <p>服务单号：-</p> -->
                </div>
              </div>
              <div class="trajectory-mid">
                <span>深圳</span>
                <span>
                  <img :src="ossPath + '/pages/home/icon-arrow-right-track.png'" alt="" />
                </span>

                <span>美国</span>
              </div>
              <div class="trajectory-right">
                <div class="trajectory-status">最新状态</div>
                <div class="trajectory-list">
                  <div class="trajectory-time">
                    {{initTrackList[0].dateTime}}
                  </div>
                  <div class="trajectory-end">
                    <p>
                      {{initTrackList[0].name}}
                    </p>
                    <p>{{initTrackList[0].namee}}</p>
                  </div>
                </div>
                <i v-if="!initOpen" class="el-icon-arrow-down" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="initOpen = true"></i>
                <i v-else class="el-icon-arrow-up" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="initOpen = false"></i>
              </div>
            </div>
            <div class="trajectory-footer" v-if="initOpen">
              <div class="GuessWrap">
                <!-- 相同轨迹 -->
                <div
                  style="width: 100%; float: left"
                >
                  <div class="show-circle" v-for="(item, index) in initTrackList" :key="index">
                    <div class="show-left">{{ item.dateTime }}</div>
                    <div class="show-right">
                      <div class="show-t1"></div>
                      <div class="show-t3"></div>
                      <div class="show-t2">
                        <div class="show-data">{{ item.name }}</div>
                        <div class="show-data-1">{{ item.namee }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 相同轨迹 end-->
              </div>
            </div>
          </div>
        </div>

        <div class="trajectory-info">
          <div class="trajectory-all">
            <div class="trajectory-top">
              <div class="trajectory-left">
                <div class="trajectory-imgs">
                  <img :src="ossPath + '/pages/home/icon-order-track.png'" alt="" />
                </div>
                <div class="trajectory-order">
                  <p>订单号：CNUS01HY2203280164</p>
                  <p>客户单号：MRSE2223423</p>
                  <!-- <p>服务单号：-</p> -->
                </div>
              </div>
              <div class="trajectory-mid">
                <span>深圳</span>
                <span>
                  <img :src="ossPath + '/pages/home/icon-arrow-right-track.png'" alt="" />
                </span>

                <span>美国</span>
              </div>
              <div class="trajectory-right">
                <div class="trajectory-status">最新状态</div>
                <div class="trajectory-list">
                  <div class="trajectory-time">
                    {{initTrackList[0].dateTime}}
                  </div>
                  <div class="trajectory-end">
                    <p>
                      {{initTrackList[0].name}}
                    </p>
                    <p>{{initTrackList[0].namee}}</p>
                  </div>
                </div>
                <i v-if="!initBoxOpen" class="el-icon-arrow-down" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="initBoxOpen = true"></i>
                <i v-else class="el-icon-arrow-up" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="initBoxOpen = false"></i>
              </div>
            </div>

            <div class="trajectory-footer" v-if="initBoxOpen" style="max-height: inherit">
              <div class="GuessWrap">
                <!-- 二维数组轨迹 -->
                <el-collapse style="border: none">
                  <el-collapse-item
                    v-for="(item, index) in initActivities"
                    :key="index"
                  >
                    <template slot="title">
                      <div class="LR_center" style="width: 100%; float: left">
                        <div style="float: left">
                          <span style="padding-left: 15px">箱子{{index + 1}} {{item.commonNos}}</span>
                          <span style="padding-left: 15px; font-weight: bold">{{initTrackList[0].name}}</span>
                          <span style="padding-left: 15px; font-weight: bold">{{initTrackList[0].namee}}</span>
                          <span style="padding-left: 15px; color: #999">{{initTrackList[0].dateTime}}</span>
                        </div>
                        <div style="float: right; color: #FF4D01">更多轨迹</div>
                      </div>
                    </template>
                    <div style="max-height: 405px; overflow: auto;">
                      <el-timeline style="padding: 0 30px">
                        <el-timeline-item
                          type="primary"
                          v-for="(activity, _index) in initTrackList"
                          :color="activity.color"
                          :key="_index"
                        >
                          <div style="width: 100%; float: left; margin-bottom: 5px">
                            {{ activity.dateTime
                            }}
                          </div>
                          <div style="color: #999; font-size: 11px; display: block">
                            <span>{{ activity.name }}</span>
                            <!-- <span style="margin-left: 10px" v-if="activity.desc"
                              >({{ activity.desc }})</span
                            > -->
                            <span>{{ activity.namee }}</span>
                            <!-- <el-button
                              type="text"
                              v-if="activity.apptWarehouseOrderId"
                              @click="GetshowText(activity)"
                              >查询回执</el-button
                            > -->
                          </div>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-collapse-item>
                </el-collapse>

                <!-- 二维数组轨迹 end-->
              </div>
            </div>
          </div>
        </div>
      </div>

      </div>
      <!-- <div
        class="track-box"
        v-else-if="activities.length == 0 && isNoTrack == false"
      >
        <div slot="empty" class="emptyClass">
          <div>
            <img
              src="@/assets/imgs/query.png"
              alt="暂无数据"
              width="295"
              height="253"
            />
          </div>
          <p class="empty-text" v-if="isKong == false">请输入查询单号</p>
        </div>
      </div> -->

      <template v-else>
        <!-- 轨迹查询 -->
        <div class="trajectory-info" v-if="activities.length != 0">
          <div class="trajectory-all">
            <div class="trajectory-top">
              <div class="trajectory-left">
                <div class="trajectory-imgs">
                  <img src="@/assets/imgs/num.png" alt="" />
                </div>
                <div class="trajectory-order">
                  <p>订单号：{{ infoData.orderNo || "-" }}</p>
                  <p>客户单号：{{ infoData.customerOrderNo || "-" }}</p>
                  <!-- <p>服务商单号：{{ infoData.thirdNo || "-" }}</p> -->
                </div>
              </div>
              <div class="trajectory-mid">
                <span>{{ infoData.fromCityName || "-" }}</span>
                <span>
                  <img src="@/assets/imgs/transport.png" alt="" />
                </span>

                <span>{{ infoData.toCountryName || "-" }}</span>
              </div>
              <div class="trajectory-right">
                <div class="trajectory-status">最新状态</div>
                <div class="trajectory-list">
                  <div class="trajectory-time">
                    {{ infoData.occurrenceDate || "-" }}
                    {{ infoData.occurrenceTime || "-" }}
                  </div>
                  <div class="trajectory-end">
                    <p>
                      {{ infoData.trackNamec || "-" }} {{
                        infoData.trackLocation ? `(${infoData.trackLocation})` : ''
                      }}
                    </p>
                    <p>{{ infoData.trackNamee || "-" }}</p>
                  </div>
                </div>
                <i v-if="!infoData.open" class="el-icon-arrow-down" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="$set(infoData, 'open', true)"></i>
                <i v-else class="el-icon-arrow-up" style="font-size: 20px; margin-left: 100px; cursor: pointer" @click="$set(infoData, 'open', false)"></i>
              </div>
            </div>
            <div class="trajectory-footer" v-if="infoData.open">
              <div class="GuessWrap">
                <!-- 二维数组轨迹 -->
                <el-collapse v-if="this.activities[0].fbxBoxTrailDTOList">
                  <el-collapse-item
                    v-for="(item, index) in activities"
                    :key="index"
                  >
                    <template slot="title">
                      <div class="LR_center" style="width: 100%; float: left">
                        <div style="float: left">
                          <span style="padding-left: 15px">{{
                            item.commonNos
                          }}</span>
                          <span style="padding-left: 15px; font-weight: bold">{{
                            item.name
                          }}</span>
                          <span style="padding-left: 15px; font-weight: bold">{{
                            item.namee
                          }}</span>
                          <span style="padding-left: 15px; color: #999">{{
                            item.occurrenceDate
                          }}</span>
                          <span style="padding-left: 5px; color: #999">{{
                            item.occurrenceTime
                          }}</span>
                        </div>
                        <div style="float: right; color: #67c23a">更多轨迹</div>
                      </div>
                    </template>
                    <el-timeline style="padding: 0 30px">
                      <el-timeline-item
                        type="primary"
                        v-for="(activity, _index) in item.fbxBoxTrailDTOList"
                        :color="activity.color"
                        :key="_index"
                      >
                        <div style="width: 100%; float: left; margin-bottom: 5px">
                          {{ activity.occurrenceDate
                          }}<span style="margin-left: 5px">{{
                            activity.occurrenceTime
                          }}</span>
                        </div>
                        <div style="color: #999; font-size: 11px; display: block">
                          <span>{{ activity.name }}</span>
                          <span style="margin-left: 10px" v-if="activity.desc"
                            >({{ activity.desc }})</span
                          >
                          <span>{{ activity.namee }}</span>
                          <el-button
                            type="text"
                            v-if="activity.apptWarehouseOrderId"
                            @click="GetshowText(activity)"
                            >查询回执</el-button
                          >
                        </div>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>

                <!-- 二维数组轨迹 end-->
                <!-- 相同轨迹 -->
                <div
                  style="width: 100%; float: left"
                  v-if="!activities[0].fbxBoxTrailDTOList"
                >
                  <div class="show-circle" v-for="(item, index) in activities" :key="index">
                    <div class="show-left">{{ item.occurrenceDate + " " + item.occurrenceTime }}</div>
                    <div class="show-right">
                      <div class="show-t1"></div>
                      <div class="show-t3"></div>
                      <div class="show-t2">
                        <div class="show-data">{{ item.name }} {{ item.desc ? `(${item.desc})` : '' }}</div>
                        <div class="show-data-1">{{ item.namee }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 相同轨迹 end-->
              </div>
            </div>
          </div>
        </div>

        <!-- 缺省页 -->
        <div class="empty-box" v-else>
          <div v-if="this.isEmpty" slot="empty" class="emptyClass">
            <div>
              <img
                src="@/assets/imgs/query.png"
                alt="暂无数据"
                width="295"
                height="253"
              />
            </div>

            <p class="empty-text" v-if="isKong">查无结果，请检查订单号是否有误</p>
            <p class="empty-text" v-else>请输入查询单号</p>
          </div>

          <div v-if="isNoTrack" slot="empty" class="emptyClass">
            <div>
              <img
                src="@/assets/imgs/orderNo.png"
                alt="暂无数据"
                width="308"
                height="163"
              />
            </div>
            <p class="empty-text">您输入的订单号有误,请输入正确的订单号~</p>
          </div>
        </div>
      </template>
    </div>
    <!-- 查看回执 -->
    <el-dialog
      style="padding-left: 100px"
      title="查看回执"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <div v-for="(item, index) in imagesList" :key="index">
        <el-image :src="item"></el-image>
      </div>
      <el-alert
        v-if="!imagesList"
        title="未上传回执"
        type="info"
        center
        show-icon
      >
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.stop="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      queryIng: 'CNUS01HY2203280164',
      initOpen: true,
      initBoxOpen: false,
      initTrackList: [
        { name: '派送完成', namee: 'Delivery complete', dateTime: '2023-03-28 12:08:00', color: '#409EFF' },
        { name: '派送异常', namee: 'Delivery abnormalities', dateTime: '2023-03-28 15:11:00', color: '#909399' },
        { name: '派送中', namee: 'Delivering', dateTime: '2023-03-28 08:40:00', color: '#909399' },
        { name: '尾程服务商已揽收', namee: 'The end-of-trip service provider has taken the collection', dateTime: '2023-03-28 03:00:00', color: '#909399' },
        { name: '已拆柜,交派送', namee: 'Dismantled and delivered', dateTime: '2023-03-27 23:40:00', color: '#909399' },
        { name: '已提柜,待拆柜', namee: 'The cabinet has been lifted and is to be dismantled', dateTime: '2023-03-27 21:20:00', color: '#909399' },
        { name: '等待提柜', namee: 'Wait for pickup', dateTime: '2023-03-27 19:56:00', color: '#909399' },
        { name: '查验中', namee: 'Under inspection', dateTime: '2023-03-27 12:59:00', color: '#909399' },
        { name: '清关中', namee: 'Custom clearance processing', dateTime: '2023-03-27 15:29:00', color: '#909399' },
        { name: '实际到港', namee: 'Actual arrival', dateTime: '2023-03-27 20:46:00', color: '#909399' },
        { name: '预计到港', namee: 'Expected arrival', dateTime: '2023-03-27 18:00:00', color: '#909399' },
        { name: '实际开船', namee: 'Actual sailing', dateTime: '2023-03-26 08:52:00', color: '#909399' },
        { name: '预计开船', namee: 'Expected to sail', dateTime: '2023-03-26 07:49:00', color: '#909399' },
        { name: '已出仓（专线）', namee: 'Out of warehouse（special railway line）', dateTime: '2023-03-25 00:10:00', color: '#909399' },
        { name: '已入仓（专线）', namee: 'Warehousing（special railway line）', dateTime: '2023-03-24 23:20:00', color: '#909399' },
        { name: '已揽收（专线）', namee: 'Received（special railway line）', dateTime: '2023-03-24 18:16:00', color: '#909399' },
        { name: '已出仓（分拨中心）', namee: 'Out of warehouse（Allocation Centre）', dateTime: '2023-03-24 16:14:00', color: '#909399' },
        { name: '已退仓', namee: 'Returned to warehouse', dateTime: '2023-03-24 15:40:00', color: '#909399' },
        { name: '已入仓（分拨中心）', namee: 'Warehousing（Allocation Centre）', dateTime: '2023-03-23 22:43:00', color: '#909399' },
        { name: '已揽收（分拨中心）', namee: 'Received（Allocation Centre）', dateTime: '2023-03-23 20:36:00', color: '#909399' },
        { name: '已安排提货', namee: 'Delivery has been arranged', dateTime: '2023-03-23 18:08:00', color: '#909399' },
        { name: '订单审核', namee: 'Order approved', dateTime: '2023-03-23 15:19:00', color: '#909399' },
        { name: '订单创建', namee: 'Order creation', dateTime: '2023-03-23 03:33:00', color: '#909399' }
      ],
      initActivities: [
        {
          commonNos: 'CNUS01HY2203280164001' // 箱号
        },
        {
          commonNos: 'CNUS01HY2203280164002' // 箱号
        },
        {
          commonNos: 'CNUS01HY2203280164003' // 箱号
        }
      ],
      infoData: {}, // 头部信息
      imagesList: [],
      dialogVisible: false,
      activities: [],
      inos: "",
      isEmpty: false,
      isNoTrack: false,
      isDefault: true,
      isKong: true,
      typeNum: 1, // 1:表示展示 2：表示隐藏
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 查询轨迹
    Searchgj() {
      // debugger
      let flag = true;
      this.queryIng = this.inos
      if (!this.inos) {
        if (flag) {
          this.isNoTrack = false;
          this.isKong = false;
          this.isEmpty = false;
          return;
        }
        this.isKong = false;
        this.isDefault = false;
        this.activities = [];
        this.isNoTrack = false;
        return;
      }
      this.initOpen = true
      this.initBoxOpen = false
      this.axios
        .post(`/track/queryOrderTrackAndBasicInfo?commonNo=${this.inos}`)
        .then((res) => {
          console.log("9999", res);
          if (res.data.code == "200") {
            if (!res.data.data) {
              this.isNoTrack = true;
              this.activities = []
              return;
            }
            if (res.data.data.orderTrailNewDTOList.length > 0) {
              res.data.data.orderTrailNewDTOList.forEach((item) => {
                this.$set(item, "color", "#909399");
              });
              res.data.data.orderTrailNewDTOList[0].color = "#409EFF";
              this.activities = res.data.data.orderTrailNewDTOList;
              this.isEmpty = false;
              this.isNoTrack = false;
              this.isDefault = false;
              this.isKong = true;
              if (res.data.data.orderTrackBasicInfoDTO) {
                this.infoData = res.data.data.orderTrackBasicInfoDTO;
                this.$set(this.infoData, 'open', true)
              }
            } else {
              this.activities = [];
              this.activities.length = 0;
              this.isNoTrack = true;
              this.isEmpty = false;
              this.isDefault = false;
            }
          } else {
            this.activities = [];
            this.activities.length = 0;
            this.isKong = true;
            this.isEmpty = true;
            this.isNoTrack = false;
            this.isDefault = false;
          }
        })
        .catch((res) => {});
    },
    // 查询约仓单回执
    GetshowText(item) {
      this.axios
        .post(
          `/fbxTrail/findApptWarehouseOrderReceipt/${item.apptWarehouseOrderId}`
        )
        .then((res) => {
          if (res.data.code == "200") {
            this.imagesList = res.data.datas;
            this.dialogVisible = true;
            this.isDefault = false;
          } else {
            this.$message(res.data.message);
          }
        })
        .catch((res) => {});
    },
    // 清空输入框
    handleClear() {
      console.log("handleClear");
      this.activities = [];
      this.isNoTrack = false;
    },
  },
  created() {
    this.$store.commit('changeHeadType', 2)
    this.$store.commit("changeactive", 2)
    if(this.$route.query.innos) {
      this.inos = this.$route.query.innos
      this.Searchgj()
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.text{
  margin-bottom: 20px;
  width: 1200px;
  height: 50px;
}
.textBox{
  font-size: 24px;
  font-weight: bold;
  margin: 40px 40px;
}
.GuessWrap {
  width: 1100px;
  padding: 50px 0;
  overflow: hidden;
  margin: 0 auto;
}
.OrderDetails {
  box-sizing: border-box;
  margin: 0 auto;
  width: 1100px;
  min-height: 626px;
  position: relative;
}
.OrderDetails .occurrence {
  position: absolute;
  left: -36px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
  text-align: right;
  width: 150px;
}
.jackContent {
  margin-top: 30px;
  padding: 10px;
  .el-timeline-item__content {
    width: 500px;
  }
}

.jackContent {
  padding: 10px;
  padding-left: 140px;
}

.el-timeline-item__timestamp .is-bottom {
  margin-left: -163px !important;
  margin-top: -30px !important;
}

.jackContent /deep/ .is-bottom {
  margin-left: -163px !important;
  margin-top: -90px !important;
}
.jackContent /deep/ .el-timeline-item {
  height: 40px !important;
}
.tips {
  margin: 4px 0 20px 0;
  height: 30px;
  font-size: 10px;
  color: #999;
}

.empty-box {
  position: relative;
  padding: 100px 50px;
}

.emptyClass {
  display: flex;
  justify-content: center;
  // align-items: center;
}

.empty-text {
  position: absolute;
  bottom: 50px;
}

.track-box {
  position: absolute;
  width: 99%;
  height: 410px;
  top: 160px;
}
</style>

<style lang="scss" scoped>
.trajectory {
  width: 700px;
  height: 50px;
  margin: 50px 0;
}
.trajectory >>> .el-input-group__append {
  width: 160px;
  text-align: center;
  color: white;
  background: #FF4D01;
  border: 1px solid #FF4D01;
  cursor: pointer;
}
.trajectory >>> .el-input__inner {
  height: 50px;
}
.empty-text {
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  font-family: PingFang SC;
  margin: 20px 0;
}

.trajectory-info {
  width: 1200px;
  // height: 591px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #0000000f;
  border-radius: 30px;
  margin: 0 auto 50px;
}

.trajectory-top {
  width: 100%;
  height: 107px;
  display: flex;
}

.trajectory-left {
  width: 30%;
  display: flex;
  align-items: center;
  .trajectory-imgs {
    margin: 0 20px 0 30px;
  }
  .trajectory-order {
    p {
      line-height: 26px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
}

.trajectory-mid {
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #341418;
    margin: 0 10px;
    img {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.trajectory-right {
  width: 45%;
  display: flex;
  align-items: center;
  .trajectory-status {
    min-width: 70px;
    height: 30px;
    background: #ffebe4;
    border: 1px solid #FF4D01;
    border-radius: 10px;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FF4D01;
    margin-right: 18px;
  }
  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-right: 12px;
  }
}
.trajectory-footer {
  width: 100%;
  border-top: 1px solid #ececec;
  max-height: 484px;
  overflow: auto;
}

li:first-child.el-timeline-item >>> .el-timeline-item__node--primary {
  width: 5px;
  height: 5px;
  background-color: #ffffff !important;
  border-radius: 50%;
  border: 4px solid#FF4D01;
}
.trajectory-list {
  display: flex;
  align-items: center;
}
.trajectory-time {
  width: 120px;
}
.trajectory-end {
  flex: 1;
  margin-top: 12px;
  p {
    margin-top: 10px;
  }
}
</style>

<style lang="scss" scoped>
.show-circle {
  display: flex;
  height: 80px;
}
.show-left {
  margin-right: 50px;
  color: #999;
}
.show-right {
  position: relative;
}

.show-t1 {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #fff !important;
  border-radius: 50%;
  border: 4px solid #FF4D01;
}

.show-t2 {
  margin-left: 50px;
}

.show-t3 {
  position: absolute;
  height: 80px;
  width: 2px;
  top: 13px;
  left: 5px;
  background: #f1f1f1f1;
}


.show-data-1 {
  margin-top: 12px;
}
.show-t1 {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #999 !important;
  border-radius: 50%;
  border: 4px solid #999;
}

.show-circle {
  &:nth-child(1) {
    .show-t1 {
      position: absolute;
      width: 5px;
      height: 5px;
      background-color: #fff !important;
      border-radius: 50%;
      border: 4px solid #FF4D01;
    }
  }
  &:last-child{
    .show-right{
      .show-t3{
        height: 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/Trajectory.vue